import ExportPage from './components/ExportPage.vue';

export default {
  routes: [
    {
      path: '/',
      component: ExportPage,
      name: 'export',
    },
  ],
};
